import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, string } from "yup";
import PURCHASEIRQAddressView from "../views/IrqAddressView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqAddressPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            street: string().required("This field is required"),
            city: string().required("This field is required"),
            state: string().required("This field is required"),
            zip: string().required("This field is required"),
          })}
        >
          <PURCHASEIRQAddressView
            content={contentMap.RefinanceIrqAddressPage}
            navigationsAway={customNavigationMap.RefinanceIrqAddressPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqAddressPage);
